// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"e6ee5d80","212":"76467e60","313":"91c3a140","554":"88cab8d2"}[chunkId] + ".chunk.css";
};